import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import en from '../translations/en';

const messages = {
  en,
};

export function IntlProvider({ children }) {
  // You can make this dynamic based on user preferences or browser settings
  const locale = navigator.language.split(/[-_]/)[0]; // Gets browser language
  
  return (
    <ReactIntlProvider
      messages={messages[locale] || messages.en}
      locale={locale}
      defaultLocale="en"
    >
      {children}
    </ReactIntlProvider>
  );
} 